var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_234_7659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.25 4.565L8.25 0.565C8.17156 0.529046 8.08629 0.510435 8 0.510435C7.91371 0.510435 7.82844 0.529046 7.75 0.565L0.75 4.565C0.675642 4.61122 0.613892 4.67513 0.570266 4.75104C0.526641 4.82695 0.5025 4.91248 0.5 5V11.5C0.50028 11.5923 0.526122 11.6828 0.574662 11.7613C0.623201 11.8399 0.692543 11.9034 0.775 11.945L7.775 15.445C7.84479 15.4802 7.92185 15.4985 8 15.4985C8.07815 15.4985 8.15521 15.4802 8.225 15.445L15.225 11.945C15.3075 11.9034 15.3768 11.8399 15.4253 11.7613C15.4739 11.6828 15.4997 11.5923 15.5 11.5V5C15.5003 4.91189 15.4774 4.82526 15.4335 4.74887C15.3896 4.67248 15.3263 4.60905 15.25 4.565ZM8 1.575L13.94 4.97L11.32 6.28L8.775 4.585C8.66522 4.52611 8.5374 4.51033 8.41659 4.54074C8.29578 4.57115 8.19067 4.64557 8.12186 4.74942C8.05304 4.85327 8.02547 4.97907 8.04455 5.10218C8.06363 5.22529 8.12798 5.33685 8.225 5.415L10.29 6.795L8 7.94L2.06 4.97L8 1.575ZM1.5 5.81L7.5 8.81V14.19L1.5 11.19V5.81ZM8.5 14.19V8.81L11 7.56V9.5C11 9.63261 11.0527 9.75978 11.1464 9.85355C11.2402 9.94732 11.3674 10 11.5 10C11.6326 10 11.7598 9.94732 11.8536 9.85355C11.9473 9.75978 12 9.63261 12 9.5V7.06L14.5 5.81V11.19L8.5 14.19Z",
    fill: "#2C20DF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_234_7659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageIcon);
export default __webpack_public_path__ + "static/media/PackageIcon.18ad01d5f9e05a1e5169d23a9940770a.svg";
export { ForwardRef as ReactComponent };